export const REGEX = {
  integer: /^-?\d+$/,
  float: /^-?(\d+)?(\.\d+)?$/,
  string: /[\s\S]*/,
  multilineText: /[\s\S]*/,
  boolean: /true|false/,
  file: /[\s\S]*/,
  object: /[\s\S]*/,
  validation: /[\s\S]*/,
  IDENTIFIER: /^[a-zA-Z][a-zA-Z0-9_]*$/,
  UUID: /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
  PARAMETER_IDENTIFIER: /<<[^>>]*>>/g,
  INSTRUMENT_NAME: /^[A-Za-z0-9-]+$/,
};

export const testRegex = (regex: RegExp, value: string) => {
  return regex.test(value);
};